import { mcApi } from './services/McApi';

export const DEFAULT_UPLOAD_BUCKET = 'airtableuploads';

class AwsService {
  REGION: string;
  BUCKET: string;

  constructor() {
    this.REGION = 'us-east-2';
    this.BUCKET = DEFAULT_UPLOAD_BUCKET;
  }

  async checkIfS3FileExists(filename: string) {
    try {
      const url = this.urlFor(filename);
      const response = await fetch(url, {
        // TODO we need to confirm that this is the right behavior...
        cache: 'reload',
        method: 'HEAD',
      });

      return response.ok;
    } catch (ex) {
      return false;
    }
  }

  upload(
    filename: string,
    body: Blob,
    contentType: string,
    { bucket }: { bucket: string } = {
      bucket: this.BUCKET,
    },
  ) {
    console.log(`aws - upload:`, { filename, body, contentType });

    const params = {
      Bucket: bucket,
      Key: filename,
      Body: body,
      ContentType: contentType,
    };

    return this.uploadFile(params);
  }

  isEncoded(uri: string) {
    if (uri.includes('%')) {
      if (uri.includes(' ')) {
        return false;
      }

      return true;
    }

    return false;
    // uri = uri || '';

    // return uri !== decodeURIComponent(uri);
  }

  fullyDecodeURI(uri: string) {
    while (this.isEncoded(uri)) {
      uri = decodeURIComponent(uri);
    }

    return uri;
  }

  urlFor(filename: string, bucket = this.BUCKET) {
    if (this.isEncoded(filename)) {
      return `https://${bucket}.s3.${this.REGION}.amazonaws.com/${filename}`;
    } else {
      return `https://${bucket}.s3.${this.REGION}.amazonaws.com/${encodeURIComponent(filename)}`;
    }
  }

  async download(bucket: string, key: string): Promise<Uint8Array | undefined> {
    try {
      const result = await mcApi.downloadFileFromS3(bucket, key);

      if (!result.success || !result.blob) {
        throw new Error(result.error || 'Download failed');
      }

      // Convert Blob to Uint8Array to match the expected return type
      const arrayBuffer = await result.blob.arrayBuffer();

      return new Uint8Array(arrayBuffer);
    } catch (err: any) {
      console.error('Failed to download file from S3:', err);

      return undefined;
    }
  }

  private async uploadFile(params: {
    Bucket: string;
    Key: string;
    Body: Blob | Uint8Array | Buffer;
    ContentType?: string;
  }): Promise<string> {
    // Convert Body to Blob if needed
    let fileBlob: Blob;

    if (params.Body instanceof Blob) {
      fileBlob = params.Body;
    } else {
      // Use type assertion to satisfy TypeScript
      fileBlob = new Blob([params.Body as any], { type: params.ContentType });
    }

    // Upload using the new McApi service
    const result = await mcApi.uploadFileToS3(fileBlob, params.Bucket, params.Key);

    if (!result.success) {
      throw new Error(result.error || 'Upload failed');
    }

    // Return a mock ETag for backwards compatibility
    // The API doesn't return ETags, so we return a placeholder
    return 'upload-started';
  }
}

const s3 = new AwsService();
Object.freeze(s3);

export default s3;
